import {
  fieldSubscriberDetailsContractTerm,
  fieldSubscriberDetailsDevicePlan,
  fieldSubscriberDetailsTypeOfDevice,
  fieldSubscriberDetailsThreeYearTier,
  fieldSubscriberDetailsThreeYearHardwareCredits
} from '../../../utils/constant';

import EN from '../../../../EN.json';
import FR from '../../../../FR.json';

const hardwareCreditMap = {
  $100: 100,
  $200: 200
};

const tierMap = {
  'Low Monthly': 'Low Monthly',
  'Mensualités réduites': 'Low Monthly',
  'Zero Up Front': 'Zero Up Front',
  'Aucun acompte': 'Zero Up Front'
};

export const threeYearFieldsToClear = [
  fieldSubscriberDetailsDevicePlan,
  fieldSubscriberDetailsTypeOfDevice,
  fieldSubscriberDetailsThreeYearTier,
  fieldSubscriberDetailsThreeYearHardwareCredits
];

export const getValueTier = (tier, credit) => {
  return { tier: tierMap[tier], hardwareCredit: hardwareCreditMap[credit] };
};

export const isDevicesFieldVisible = (formFields, locale) => {
  const {
    contentfulValues: {
      wirelessOrderDetails: {
        valueBasicEasyPayment,
        valueVoiceOnly,
        valueThreeYear,
        valueTablet,
        valueWatch,
        valueMobileHighSpeedSmartHub
      }
    }
  } = locale === 'en-US' ? EN : FR;

  if (
    formFields &&
    formFields[fieldSubscriberDetailsContractTerm] &&
    formFields[fieldSubscriberDetailsContractTerm].value === valueThreeYear
  ) {
    if (
      formFields[fieldSubscriberDetailsDevicePlan] &&
      formFields[fieldSubscriberDetailsDevicePlan].value ===
        valueBasicEasyPayment
    ) {
      return true;
    }
    if (
      formFields[fieldSubscriberDetailsDevicePlan] &&
      formFields[fieldSubscriberDetailsDevicePlan].value === valueWatch
    ) {
      return true;
    }
    if (
      formFields[fieldSubscriberDetailsDevicePlan] &&
      formFields[fieldSubscriberDetailsDevicePlan].value === valueTablet
    ) {
      return true;
    }
    if (
      formFields[fieldSubscriberDetailsDevicePlan] &&
      formFields[fieldSubscriberDetailsDevicePlan].value ===
        valueMobileHighSpeedSmartHub
    ) {
      return true;
    }
    if (
      formFields[fieldSubscriberDetailsTypeOfDevice] &&
      formFields[fieldSubscriberDetailsTypeOfDevice].value === valueVoiceOnly
    ) {
      return true;
    }

    if (
      formFields[fieldSubscriberDetailsThreeYearTier] &&
      formFields[fieldSubscriberDetailsThreeYearHardwareCredits] &&
      formFields[fieldSubscriberDetailsThreeYearTier] &&
      formFields[fieldSubscriberDetailsThreeYearHardwareCredits].value
    ) {
      return true;
    }

    return false;
  }
  return true;
};
